import * as React from 'react';
import { TooltipHost } from '@fluentui/react';
import PropTypes from 'prop-types';
import { useId } from '@fluentui/react-hooks';
import { convertToText } from '../../utils/stringUtils';

import './Tooltip.scss';

const calloutProps = { gapSpace: 4 };
export const Tooltip = ({ textContent, id, children }) => {
  const tooltipId = useId(id);
  const tooltipContent = () => {
    return (
      <div className='tooltip-content'>
        {convertToText(textContent)}
      </div>
    );
  };
  const tooltipProps = {
    onRenderContent: tooltipContent,
  };

  return (
    <TooltipHost tooltipProps={tooltipProps}
      id={tooltipId}
      calloutProps={calloutProps}
      content={children}
    >
      {children}
    </TooltipHost>
  );
};

Tooltip.propTypes = {
  textContent: PropTypes.any,
  id: PropTypes.string,
  children: PropTypes.element,
};
